import React from "react";
import { Seo } from "../../components/Layout";
import { PageHero, InternalLinkCard, EndCTA } from "../../components/PageParts";

const BREADCRUMB = [{ to: "/", label: "Accueil" }, { label: "Votre séance" }];

const CARDS = [
  { to: "/votre-seance/deroulement", eyebrow: "Le format", title: "Déroulement d'une séance", description: "Ce qui se passe concrètement, du premier échange à l'intégration finale — pour aborder votre séance sereinement." },
  { to: "/votre-seance/en-ligne", eyebrow: "À distance", title: "Séance d'hypnose en ligne", description: "Comment se déroule une séance en visioconférence, et pourquoi l'expérience reste pleinement qualitative." },
  { to: "/votre-seance/cabinet-pantin", eyebrow: "Sur place", title: "Le cabinet à Pantin", description: "Adresse, accès, cadre. Un espace calme à 15 min de Paris, au métro Église de Pantin (ligne 5)." },
  { to: "/votre-seance/tarifs", eyebrow: "Transparence", title: "Tarifs", description: "80 € pour l'hypnose ericksonienne, 120 € pour l'hypnose spirituelle. Modalités de règlement." },
  { to: "/votre-seance/a-propos", eyebrow: "Qui je suis", title: "À propos de Valentine DL", description: "Un mot sur mon approche et ce qui guide mon accompagnement au quotidien." },
  { to: "/votre-seance/temoignages", eyebrow: "Retours", title: "Avis & témoignages", description: "Ce que disent celles et ceux que j'ai eu la joie d'accompagner." },
];

export default function VotreSeanceLanding() {
  return (
    <>
      <Seo
        title="Votre séance — Informations pratiques"
        description="Tout ce qu'il faut savoir sur une séance d'hypnose avec Valentine DL : déroulement, séance en ligne, cabinet à Pantin, tarifs, avis. Pour aborder votre première séance sereinement."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance"
      />

      <PageHero
        breadcrumb={BREADCRUMB}
        eyebrow="Votre séance"
        title="Tout ce qu'il faut savoir"
        italic="pour être serein·e le jour J."
        subtitle="Le format, le cabinet, les tarifs, les avis — les informations pratiques réunies au même endroit."
      />

      <section className="px-6 lg:px-10 pb-20">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS.map((c) => (
            <InternalLinkCard key={c.to} {...c} testid={`vs-card-${c.to.split('/').pop()}`} />
          ))}
        </div>
      </section>

      <EndCTA title="Prêt·e à réserver&nbsp;?" text="Séances à Pantin ou en ligne. Réponse personnelle sous 24 h." testid="vs-end-cta" />
    </>
  );
}
